module.exports = __webpack_public_path__ + "iconGray.png?aa44b36a7611af72445c46c2b982e55c";